import victorPhoto from "@/assets/recommendations/victor-goncalves.jpeg";
import rodrigoPhoto from "@/assets/recommendations/rodrigo-lauretto.jpeg";
import ricardoPhoto from "@/assets/recommendations/ricardo-felipe.jpeg";
import eduardoPhoto from "@/assets/recommendations/eduardo-figurelli.jpeg";
import dayanePhoto from "@/assets/recommendations/dayane-calderon.jpeg";

export interface RecommendationTranslation {
  id: string;
  name: string;
  company: string;
  project: string;
  role: string;
  linkedin: string;
  testimony: string;
  photo: string;
}

export const recommendationsTranslations = {
  pt: {
    recommendations: [
      {
        id: "victor-goncalves",
        name: "Victor Gonçalves",
        company: ".add (AddTech)",
        project: "Departamento de Marketing",
        role: "Chief Digital Officer",
        linkedin: "https://www.linkedin.com/in/victorgoncalves-/",
        testimony: "Mais que estar conectado com as tendências tecnológicas, o Paulo consegue consistentemente realizar conexões entre a capacidade de uma tecnologia e o sentido dela aplicada ao negócio.",
        photo: victorPhoto
      },
      {
        id: "rodrigo-lauretto",
        name: "Rodrigo Lauretto",
        company: "Take Blip",
        project: "Banco Safra/AG zero",
        role: "Project Manager",
        linkedin: "https://www.linkedin.com/in/rodrigo-lauretto-7518bb53/",
        testimony: "Paulo foi uma profissional muito criativo, muito cooperativo com a equipe, comprometido com as demandas, sendo um diferencial em suas competências. Além de excelente profissional, um grande ser humano de caráter ímpar.",
        photo: rodrigoPhoto
      },
      {
        id: "ricardo-felipe",
        name: "Ricardo Felipe",
        company: "Take Blip",
        project: "Banco Safra",
        role: "Product Designer",
        linkedin: "https://www.linkedin.com/in/ricardo-felipe/",
        testimony: "Trabalhei com o Paulo por quase 6 meses e foi uma ótima experiência. Ele é uma profissional excelente! Proativo, detalhista e é alguém que aprende rápido, além de trabalhar muito bem em equipe. Você não vai se arrepender de tê-lo na sua equipe!",
        photo: ricardoPhoto
      },
      {
        id: "eduardo-figurelli",
        name: "Eduardo Figurelli",
        company: ".add (AddTech)",
        project: "Suporte a equipe de vendas",
        role: "Comercial - Vendas",
        linkedin: "https://www.linkedin.com/in/eduardo-figurelli/",
        testimony: "Paulo é um profissional preocupado em aplicar as melhores práticas nos seus trabalhos, pesquisa, busca e faz acontecer, sempre antenado com as novidades, procura estar sempre a frente nas soluções de mídias e aplicações de marketing corporativo!",
        photo: eduardoPhoto
      },
      {
        id: "dayane-calderon",
        name: "Dayane Calderon",
        company: "Ozia",
        project: "Chatbot D.A.I.",
        role: "Analista de dados e suporte",
        linkedin: "https://www.linkedin.com/in/dayane-calderon/",
        testimony: "Trabalhei com o Paulo no projeto de implementação de um chatbot integrado à IA, onde ele desempenhou um papel essencial para o sucesso da iniciativa. Sua expertise em UX Writing, aliada ao profundo conhecimento em OpenAI, foi um grande diferencial, especialmente na criação de prompts claros, estratégicos e alinhados à experiência do usuário. Paulo se destacou por sua colaboração, criatividade e habilidade única de compreender as necessidades do cliente, transformando-as em interações eficientes, humanizadas e altamente impactantes no chatbot.",
        photo: dayanePhoto
      }
    ]
  },
  en: {
    recommendations: [
      {
        id: "victor-goncalves",
        name: "Victor Gonçalves",
        company: ".add (AddTech)",
        project: "Marketing Department",
        role: "Chief Digital Officer",
        linkedin: "https://www.linkedin.com/in/victorgoncalves-/",
        testimony: "More than being connected with technological trends, Paulo consistently makes connections between a technology's capability and its business application sense.",
        photo: victorPhoto
      },
      {
        id: "rodrigo-lauretto",
        name: "Rodrigo Lauretto",
        company: "Take Blip",
        project: "Banco Safra/AG zero",
        role: "Project Manager",
        linkedin: "https://www.linkedin.com/in/rodrigo-lauretto-7518bb53/",
        testimony: "Paulo was a very creative professional, very cooperative with the team, committed to demands, being a differential in his competencies. Besides being an excellent professional, a great human being with unique character.",
        photo: rodrigoPhoto
      },
      {
        id: "ricardo-felipe",
        name: "Ricardo Felipe",
        company: "Take Blip",
        project: "Banco Safra",
        role: "Product Designer",
        linkedin: "https://www.linkedin.com/in/ricardo-felipe/",
        testimony: "I worked with Paulo for almost 6 months and it was a great experience. He is an excellent professional! Proactive, detail-oriented and someone who learns quickly, plus works very well in a team. You won't regret having him on your team!",
        photo: ricardoPhoto
      },
      {
        id: "eduardo-figurelli",
        name: "Eduardo Figurelli",
        company: ".add (AddTech)",
        project: "Sales Team Support",
        role: "Commercial - Sales",
        linkedin: "https://www.linkedin.com/in/eduardo-figurelli/",
        testimony: "Paulo is a professional concerned with applying best practices in his work, researches, seeks and makes things happen, always up to date with news, always looking to be ahead in media solutions and corporate marketing applications!",
        photo: eduardoPhoto
      },
      {
        id: "dayane-calderon",
        name: "Dayane Calderon",
        company: "Ozia",
        project: "Chatbot D.A.I.",
        role: "Data Analyst and Support",
        linkedin: "https://www.linkedin.com/in/dayane-calderon/",
        testimony: "I worked with Paulo on an AI-integrated chatbot implementation project, where he played an essential role in the initiative's success. His expertise in UX Writing, combined with deep knowledge in OpenAI, was a great differential, especially in creating clear, strategic prompts aligned with user experience. Paulo stood out for his collaboration, creativity and unique ability to understand client needs, transforming them into efficient, humanized and highly impactful chatbot interactions.",
        photo: dayanePhoto
      }
    ]
  }
};